import { setCrispSessionData } from '../../util/set-crisp-session-info'

export const setCrispSessionParams = (step: string): void => {
  setCrispSessionData({ signupStep: step })
}
